import { useEffect, useState } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';

import v2_actionCriarDirecionamento from 'src/actions/v2/cliente/v2_actionCriarDirecionamento';
import v2_actionDeleteFlowDirect from 'src/actions/v2/cliente/v2_actionDeleteFlowDirect';
import v2_actionEditarDirecionamentoDireto from 'src/actions/v2/cliente/v2_actionEditarDirecionamentoDireto';
import v2_actionListaFluxosDiretos from 'src/actions/v2/cliente/v2_actionListaFluxosDiretos';
import Page from 'src/components/Page';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import TableSkeleton from 'src/components/skeleton/TableSkeleton';
import { nomeProjeto } from 'src/config';
import useAuth from 'src/hooks/useAuth';
import { getListaSetoresTransferencia, getListaUsuariosTransferencia } from 'src/redux/slices/user';
import { Plus, Zap } from 'lucide-react';
import { DIRECIONAMENTOS_COMPONENT_DESIGN } from './DirecionamentosComponent.design';
import ModalDirecionamentos from './ModalDirecionamentos';
import Table from './TableDirecionamentos';

export default function DirecionamentosComponent() {
  const { user } = useAuth();
  const dispatch = useDispatch();

  const [openDialogNovoSetor, setOpenDialogNovoSetor] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [action, setAction] = useState('');
  const { listaUsuariosTransferencia, listaSetoresTransferencia } = useSelector((state) => state.user);
  ///// value fields
  const [direcionamentoId, setDirecionamentoId] = useState('');
  const [fluxos, setFluxos] = useState([]);
  const [recebe, setRecebe] = useState('');
  const [usersSelect, setUsersSelect] = useState([]);
  const [departamentSelect, setDepartamentSelect] = useState([]);
  const [sendMessage, setSendMessage] = useState(false);
  const [assignAi, setAssignAi] = useState(false);
  const [prompt, setPrompt] = useState('');

  const [dataMessage, setDataMessage] = useState({
    chatFiles: [],
    chatText: '',
    chatTypeMessage: 'text',
  });


  async function getList() {
    try {
      const response = await v2_actionListaFluxosDiretos(user.clienteId);
      setFluxos(response.data.data)
    } catch (error) {
      console.log(error);
    }

  }

  useEffect(() => {
    getList();
    dispatch(getListaUsuariosTransferencia(user.clienteId))
    dispatch(getListaSetoresTransferencia(user.clienteId))

  }, []);


  function applyFilter(tableData, filterName) {
    if (filterName) {
      tableData = tableData.filter(
        (item) =>
          item.nome.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
      );
    }
    return tableData;
  }

  async function handleCriarDirecionamento() {
    try {
      setLoading(true)
      const data = {
        scope: {
          direcionaUsuarios: usersSelect,
          direcionaSetores: departamentSelect,
          recebe: recebe
        }
      }
      setLoadingCreate(true)
      await v2_actionCriarDirecionamento(user.clienteId, data);
      await getList();
      setLoading(false)
      setOpenDialogNovoSetor(false);
      setRecebe('');
      setUsersSelect([]);
      setDepartamentSelect([]);
      setLoadingCreate(false)
    } catch (error) {
      setLoading(false)
      setLoadingCreate(false)
    }
  }

  async function handleDeletarTag() {
    try {
      await v2_actionDeleteFlowDirect(direcionamentoId);
      await getList();
      setRecebe('');
      setDirecionamentoId('');
      setOpenModalConfirmacao(false);
    } catch (error) {

    }
  }

  const handleEditarTag = async () => {
    try {
      let data = {
        scope: {
          direciona_usuarios: usersSelect,
          direciona_setores: departamentSelect,
          recebe: recebe,
          sendMessage: sendMessage,
          message: dataMessage,
          assignAI: assignAi,
          prompt: prompt
        }
      }
      setLoadingCreate(true)
      await v2_actionEditarDirecionamentoDireto(direcionamentoId, data);
      await getList();
      setAction('');
      setRecebe('');
      setUsersSelect([]);
      setDepartamentSelect([]);
      setDirecionamentoId('');
      setOpenDialogNovoSetor(false);
      setLoadingCreate(false)
    } catch (error) {
      setLoadingCreate(false)
      console.log('error', error)
    }

  };


  const dataFiltered = applyFilter(fluxos, pesquisa);

  return (
    <Page title={`${nomeProjeto} - Direcionamentos`}>
      <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.page.container}>

        {/* Header */}
        <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.page.header.container}>
          <div>
            <h1 className={DIRECIONAMENTOS_COMPONENT_DESIGN.page.header.title}>Direcionamentos</h1>
            <p className={DIRECIONAMENTOS_COMPONENT_DESIGN.page.header.subtitle}>
              Crie direcionamento para setores e usuários
            </p>
          </div>
          <button
            onClick={() => {
              setOpenDialogNovoSetor(true);
              setAction('Criar')
            }}
            className={DIRECIONAMENTOS_COMPONENT_DESIGN.page.actionButton}
          >
            <Plus size={18} />
            <span>Criar Direcionamento</span>
          </button>
        </div>

        <ModalConfimacao
          open={openModalConfirmacao}
          onClose={() => {
            setOpenModalConfirmacao(false);
          }}
          onConfirm={handleDeletarTag}
          loadingFinalizar={loading}
          mensagem={'Deseja mesmo excluir essa etiqueta?'}
        />

        {openDialogNovoSetor && (
          <ModalDirecionamentos
            users={listaUsuariosTransferencia}
            departaments={listaSetoresTransferencia}
            usersSelect={usersSelect}
            departamentSelect={departamentSelect}
            loadingCreate={loadingCreate}
            changeDepartament={(e) => {
              setDepartamentSelect(e)

            }}
            changeUser={(e) => {
              setUsersSelect(e)
            }}
            open={openDialogNovoSetor}
            action={action}
            recebe={recebe}
            changeRecebe={(e) => {
              setRecebe(e.target.value)
            }}
            onSubmit={action === "Criar" ? handleCriarDirecionamento : handleEditarTag}
            onClose={() => {
              setOpenDialogNovoSetor(false);
              setRecebe('');
              setDirecionamentoId('');
              setUsersSelect([]);
              setDepartamentSelect([]);
              setAssignAi(false);
              setPrompt('');
            }}
            sendMessage={sendMessage}
            changeSendMessage={(e) => {

              setSendMessage(e)
            }}
            data={dataMessage}
            assignAi={assignAi}
            prompt={prompt}
            changeAssignAI={(e) => {
              setAssignAi(e)
            }}
            changePrompt={(e) => {
              setPrompt(e.target.value)
            }}
            changeBlock={(e) => {
              const { name, value } = e;
              if (name === "chatTypeMessage") {
                setDataMessage({
                  ...dataMessage,
                  chatTypeMessage: value
                })
              } else if (name === "chatText") {
                setDataMessage({
                  ...dataMessage,
                  chatText: value
                })

              } else if (name === "chatFiles") {
                setDataMessage({
                  ...dataMessage,
                  chatFiles: value
                })
              }
            }}
          />
        )}

        {/* List */}
        <div className="flex flex-col gap-4">
          {loading ? (
            <TableSkeleton />
          ) : fluxos.length === 0 ? (
            <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyState.container}>
              <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyState.iconBox}>
                <Zap size={32} />
              </div>
              <h3 className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyState.title}>Nenhum direcionamento criado</h3>
              <p className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyState.description}>
                Crie seu primeiro direcionamento para organizar o fluxo de atendimento.
              </p>
              <button
                onClick={() => {
                  setOpenDialogNovoSetor(true);
                  setAction('Criar')
                }}
                className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyState.button}
              >
                Criar direcionamento
              </button>
            </div>
          ) : (
            <Table
              data={dataFiltered}
              onDelete={row => {
                setDirecionamentoId(row._id);
                setOpenModalConfirmacao(true);
              }}
              onEdit={row => {
                setOpenDialogNovoSetor(true)
                setDepartamentSelect(row.direciona_setores);
                setUsersSelect(row.direciona_usuarios);
                setAction('Editar')
                setDirecionamentoId(row._id);
                setRecebe(row.recebe);
                setPrompt(row.prompt);
                setAssignAi(true);
              }}
            />
          )}
        </div>
      </div>
    </Page>
  );
}
